export enum SpaceModel {
  POD = 'POD',
  SEAT = 'SEAT',
  ROOM = 'ROOM',
}
